import { render } from "./NPSQuestionResult.vue?vue&type=template&id=42e68aaa&scoped=true"
import script from "./NPSQuestionResult.vue?vue&type=script&lang=js"
export * from "./NPSQuestionResult.vue?vue&type=script&lang=js"

import "./NPSQuestionResult.vue?vue&type=style&index=0&id=42e68aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e68aaa"]])

export default __exports__